// Helper functions for manually triggering Web Agent download and Asset Updates from Advanced Settings

/**
 * Triggers platform-specific Web Agent download
 */
export const downloadWebAgent = async () => {
    try {
        // Get platform and architecture information
        const { platform, architecture } =
            await navigator.userAgentData.getHighEntropyValues([
                'architecture',
                'platform',
            ])

        // Define platform-specific download links
        const downloadLinks = {
            macOS: {
                x86: 'https://tools.plode.org/plode_web_agent.pkg',
                arm: 'https://tools.plode.org/plode_web_agent.pkg',
            },
            Windows: 'https://tools.plode.org/plode_web_agent.exe',
        }

        // Determine the appropriate download link
        const downloadLink =
            platform === 'macOS'
                ? downloadLinks.macOS[architecture]
                : downloadLinks[platform]

        if (downloadLink) {
            window.open(downloadLink, '_blank')
            return { success: true, platform, architecture }
        } else {
            console.error('Unsupported platform:', platform)
            // Fallback to GitHub releases page
            window.open(
                'https://github.com/YuduRobotics/plode-web-agent/releases/latest',
                '_blank'
            )
            return { success: true, fallback: true }
        }
    } catch (error) {
        console.error('Error detecting platform:', error)
        // Fallback to GitHub releases page
        window.open(
            'https://github.com/YuduRobotics/plode-web-agent/releases/latest',
            '_blank'
        )
        return { success: true, fallback: true, error }
    }
}

/**
 * Checks if socket is available for asset update
 */
export const checkSocketAvailability = (socketData) => {
    if (!socketData?.isAgentConnected) {
        return {
            available: false,
            reason: 'Web Agent is not connected. Please install and start Web Agent first.',
        }
    }

    if (!socketData?.socket) {
        return {
            available: false,
            reason: 'Socket connection is not available.',
        }
    }

    return { available: true }
}
